const answerKeyHeader = /^(?:answer\s*key|key\s*answers|answers|مفتاح\s*الإجابة|الإجابات)(?:\s|:|：|$)/i;
const answerEntry = /^(\d{1,2})\s*[.):-]\s*\(?([a-fأ-و])\)?\s*$/i;
const questionHeader = /^(\d{1,2})\s*[.):-]\s*(.*)$/;
const optionLine = /^\(?([a-fأ-و])\)?\s*[.):-]\s*(.+)$/i;
const arabicDigits = "٠١٢٣٤٥٦٧٨٩";

function normalizeDigits(value) {
    return value.replace(/[٠-٩]/g, (digit) => String(arabicDigits.indexOf(digit)));
}

function optionIndex(label) {
    const normalized = label.toUpperCase();
    if (normalized >= "A" && normalized <= "F") {
        return normalized.charCodeAt(0) - 65;
    }

    const arabicLabels = ["أ", "ب", "ج", "د", "هـ", "و"];
    return arabicLabels.indexOf(label);
}

export function parseQuizText(rawText) {
    const lines = normalizeDigits(rawText)
        .replace(/\u00a0/g, " ")
        .split(/\r?\n/)
        .map((line) => line.trim())
        .filter(Boolean);
    const questions = [];
    const answers = new Map();
    let answerSection = false;
    let currentQuestion = null;

    lines.forEach((line) => {
        if (answerKeyHeader.test(line)) {
            answerSection = true;
            currentQuestion = null;
            return;
        }

        if (answerSection) {
            const answerMatch = line.match(answerEntry);
            if (answerMatch) {
                answers.set(Number(answerMatch[1]), optionIndex(answerMatch[2]));
            }
            return;
        }

        const questionMatch = line.match(questionHeader);
        if (questionMatch) {
            currentQuestion = {
                number: Number(questionMatch[1]),
                question: questionMatch[2],
                options: []
            };
            questions.push(currentQuestion);
            return;
        }

        const optionMatch = line.match(optionLine);
        if (optionMatch && currentQuestion) {
            currentQuestion.options.push(optionMatch[2]);
        } else if (currentQuestion && currentQuestion.options.length === 0) {
            currentQuestion.question = `${currentQuestion.question} ${line}`.trim();
        }
    });

    const validQuestions = questions.filter((question) => (
        question.question.trim()
        && question.options.length >= 2
        && question.options.length <= 6
    ));

    return {
        questions: validQuestions.map((question) => {
            const correctIndex = answers.get(question.number);
            return {
                question: question.question.trim(),
                options: question.options.map((option) => option.trim()),
                correctIndex: Number.isInteger(correctIndex)
                    && correctIndex >= 0
                    && correctIndex < question.options.length
                    ? correctIndex
                    : null
            };
        }),
        unansweredCount: validQuestions.filter((question) => (
            !Number.isInteger(answers.get(question.number))
            || answers.get(question.number) < 0
            || answers.get(question.number) >= question.options.length
        )).length
    };
}
